import {fromEvent, Observable, of} from "rxjs";
import {ConcatScroll, StopScrollEvent} from "./concat-scroll";
import {debounceTime, filter, map, switchMap, tap} from "rxjs/operators";
import {log} from "./test/rxjs-extra-ops";
import scrollIntoView from 'scroll-into-view';

/*export interface SpacerRule {

   toNext_moreThan: number;
   backToTop_lessThan: number;
}

export interface PagePreviousRule {

   toPrevious_lessThan: number;
   backToTop_lessThan: number;
}*/

export class ScrollSnapper {

   rootElement: HTMLElement;
   children: any;
   concatScroll;
   scrollEnd$;
   sections: number[];
   thresholdPx: number;
   measureHeightFrom:HTMLElement;
   windowHeight: number;

   constructor(rootElement: HTMLElement,
               measureWindowHeightFrom: HTMLElement,
               concatScroll: ConcatScroll,
               threshholdPx = 30) {
      this.rootElement = rootElement;
      this.children = jQuery(this.rootElement).find('section');
      this.concatScroll = concatScroll;
      this.scrollEnd$ = concatScroll.scrollStop$;
      this.thresholdPx = threshholdPx;
      this.measureHeightFrom = measureWindowHeightFrom;


      this.init();
   }

   init() {
      //console.log('WINDOW HEIGHT', this.windowHeight);
      this.buildPageArray();
      console.log('section', this.sections);
      fromEvent(window,'resize').pipe(
         debounceTime(100),
         tap( ()=> this.buildPageArray())
      ).subscribe();
      this.scrollEnd$.pipe(
         // onlyMovedDown,
         filter((e: StopScrollEvent) => e.movedDown),
         map(_ => this.pageDownSnapRequired()),
         filter(page => page >= 0),
         tap((page: number) => this.scrollToSection(page)),
         //log('SnapRequerd>>>???'),
         //tap( e => console.log('PAGE', e))

      ).subscribe(/*e => console.log('WTF', e)*/);

      this.scrollEnd$.pipe(
         // onlyMovedDown,
         filter((e: StopScrollEvent) => !e.movedDown),
         map(_ => this.pageUpSnapRequired()),
         filter(page => page >= 0),
         tap((page: number) => this.scrollToSection(page)),
         //log('SnapRequerd>>>???'),
         //tap( e => console.log('PAGE', e))

      ).subscribe(/*e => console.log('WTF', e)*/);
   }

   scrollToSection( num) {
      //this.concatScroll.ignoreNextScrollEvent();
      scrollIntoView(this.children[num]);
   }

   buildPageArray() {

      this.windowHeight = jQuery(this.measureHeightFrom).outerHeight();
      this.sections = [0];
      this.children.each(
         (index, el) => {
            //this.sections.push(jQuery(el).offset().top)
            this.sections.push(jQuery(el).position().top + jQuery(el).outerHeight())
         });

      console.log('pageARRAY', this.sections, 'WINDOWHEIGHT', this.windowHeight);

   }

   pageDownSnapRequired() {
      let wTop = jQuery(window).scrollTop();
      //let wBottom = wTop + jQuery(window).height();
      let wBottom = wTop + this.windowHeight;

      for (let i = 0; i < this.sections.length - 1; i++) {
         let pageHeight = this.sections[i + 1] - this.sections[i];

         // console.log(wTop, wBottom, this.sections[i], this.sections[i + 1])
         if (/*wTop > this.sections[i] && */wTop < this.sections[i + 1]
               && wBottom > this.sections[i+1]) {
            if (wBottom - this.sections[i + 1] > this.thresholdPx) {
               return i + 1;
            } else if(i == 0){
               //console.log('DOWN - DIDNT REACH THRESHOLD and fist page')
               return 0;
            }else{
               //console.log('DOWN - DIDNT REACH THRESHOLD READJUSTING')
               //console.log('READJUSTING', (this.sections[i+1] -(wBottom -wTop)));
               let offset = -1 * (pageHeight - jQuery(window).height());

               //console.log('OFFSET', offset, pageHeight, jQuery(window).height());
               scrollIntoView(this.children[1], {
                  align: {
                     top:0,
                     topOffset: offset
                     //topOffset:  (this.sections[i+1] -(wBottom -wTop))
                  }
               });
               return  - 1;
            }
         }
      }
      return -1;
   }

   pageUpSnapRequired() {
      let wTop = jQuery(window).scrollTop();
      let wBottom = wTop + this.windowHeight;

      for (let i = this.sections.length -2; i > 0; i--) {
         //let pageHeight = this.sections[i + 1] - this.sections[i];

        /* console.log('wtop '+ wTop,'wbottom '+ wBottom,
            'sections[i] ' + this.sections[i], 'sections[i-1] '+ this.sections[i - 1], this.sections)*/
         if (wTop < this.sections[i ] && wBottom > this.sections[i]) {
            if (this.sections[i] - wTop > this.thresholdPx) {
               //return i - 1;
               let prevPageHeight = this.sections[i] - this.sections[i-1];
               let offset = -1 * (prevPageHeight - jQuery(window).height());

               //console.log('OFFSET', offset, pageHeight, jQuery(window).height());
               scrollIntoView(this.children[i-1], {
                  align: {
                     top:0,
                     topOffset: offset
                     //topOffset:  (this.sections[i+1] -(wBottom -wTop))
                  }
               });
               return -1;
            } else {
               return i;
            }
         }
      }
      return -1;
   }

}


/*const pageSnapRequiredAfterDown = (obs: Observable<any>) => {

   return obs.pipe(map(e => {
      let wTop = jQuery(window).scrollTop();
      let wBottom = wTop + jQuery(window).height();

      for (let i = 0; i< this.sections.length -1 ; i++){
         let pageHeight = this.sections[i+1] - this.sections[i];
         if( wTop > this.sections[i] && wBottom > this.sections[i+1]){
            if( wBottom - this.sections[i +1 ] > 100){
               return i + 1;
            }else {
               return i;
            }
         }
      }
      return -1;
   }))

};*/
export const onlyMovedUp = () => {
   return filter((e: StopScrollEvent) => !e.movedDown)
};
export const onlyMovedDown = () => {
   return filter((e: StopScrollEvent) => e.movedDown)
};
